export default __webpack_public_path__ + "static/media/EE-Power Electronics and Power Systems.c58ed00c.pdf";